"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clientDescriptionSerializer = void 0;
var toHeaderValue = function (clientDescription) {
    return Object.keys(clientDescription)
        .map(function (key) { return (clientDescription[key] ? "".concat(key, "=").concat(clientDescription[key]) : ""); })
        .filter(function (value) { return value; })
        .join(";");
};
exports.clientDescriptionSerializer = {
    toHeaderValue: toHeaderValue,
};
